export enum Flipper {
  integrations = 'integrations',
  integrationSquare = 'rt_integrations_square',
  integrationShopify = 'integrations_shopify',
  integrationLightspeed = 'rt_integrations_lightspeed',
  integrationClover = 'rt_integrations_clover',
  integrationGoogleBusiness = 'integrations_google_business',
  integrationViaEthor = 'rt_ethor_pos_integration', // a feature toggle for the POS integration supported by eThor
  integrationYext = 'rt_yext_integration',
}
